import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth'; // Install ini: npm install react-firebase-hooks
import { auth } from '../firebase';

const ProtectedRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);

  if (loading) return <div className="h-screen flex justify-center items-center">Loading...</div>;
  
  if (!user) {
    return <Navigate to="/login-admin" />;
  }

  return children;
};

export default ProtectedRoute;